/**
 * Configuration Version
 * 
 * SINGLE SOURCE OF TRUTH for configuration schema version.
 * 
 * When to update this:
 * - Change from 1.0.0 to 2.0.0 when you make BREAKING changes to config structure
 * - Examples of breaking changes:
 *   - Renaming config fields (colors -> palette)
 *   - Changing data types (string -> object)
 *   - Removing required fields
 *   - Changing nested structure
 * 
 * When NOT to update:
 * - Adding new optional fields (backward compatible)
 * - Bug fixes
 * - UI changes that don't affect config structure
 */

export const CONFIG_VERSION = '1.0.0';

/**
 * Configuration schema version history:
 * 
 * 1.0.0 (Current)
 * - Initial configuration schema
 * - Structure: { theme: { colors, font }, logo: { logo, text }, tabs: { ... } }
 * 
 * Future versions will be documented here when config structure changes.
 */
